// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-email-addresses__add-email{display:flex;align-items:center}.edit-email-addresses__add-email a{flex:0 1 auto}", ""]);
// Exports
module.exports = exports;
